import React from 'react';
import style from './style.scss';
import {TheNews} from './sub-view/the-news';
import {AdvisoryContent} from 'components/users/sub-view/advisory-content';
import {BusinessLayout} from 'components/layouts/business';

class MyBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active='the-news'>
        <TheNews/>
        <h1 className="user-header">Tư vấn miễn phí</h1>
        <AdvisoryContent/>
      </BusinessLayout>
    );
  }
}

export default MyBusiness;



// WEBPACK FOOTER //
// ./components/my-business/MyBusiness.jsx